<template>
  <div class="property-container">
    <div v-if="header" class="property-container__header">
      {{ header }}
    </div>

    <table class="property-table">
      <tr v-for="(value, key) of items" :key="`property-table-item-${key}`" class="property-table__item">
        <td>
          {{ key }}
        </td>

        <td>
          {{ value }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    header: {
      type: String,
      default: ''
    },
    items: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style lang="scss">
.product-tabs__specification .property-container {
  width: 100%;

  @include media(medium) {
    margin-right: measure(half);
    width: auto;
  }
}

.property-container__header {
  @include body-bold;
  margin-bottom: measure(half);
}

.product-tabs__specification .property-container__header {
  @include body;
  padding-left: measure(quarter);
}

.property-table {
  border-collapse: collapse;
  border: 1px solid color(border-gray);
}

.property-table__item {
  border-top: 1px solid color(border-gray);

  &:first-child {
    border-top: 0;
  }
}

.property-table__item td {
  @include body-smaller;
  padding: measure(quarter) measure(half);

  &:first-child {
    @include body-smaller-bold;
    border-right: 1px solid color(border-gray);
  }
}
</style>
